export default __webpack_public_path__ + "static/media/error-outline.2b14b73e.svg";